import {fetchCPTFilter, getPackages} from "../network/PackageListNetworkAPI";

export const PackageReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {lineHaulId, containerId, filters, dispatcher, packageState, filterIdentifier, isCPTFilterEnabled} = action.data;
            getPackages(filters, dispatcher, lineHaulId, containerId, packageState, filterIdentifier, isCPTFilterEnabled)
            return state
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "FETCH_FILTER_IDENTIFIER":
            fetchCPTFilter(action.data.dispatcher)
            return state
        case "ASSIGN_FILTER_IDENTIFIER":
            return {...state, filterIdentifier: action.data.filterIdentifier}
        case "ASSIGN_LABEL":
            return {...state, CPTLabel: action.data.CPTLabel}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/package/reducer/PackageReducer.js